
import { FiEdit3, FiPlus, FiUsers } from "react-icons/fi";
import { NavBar } from "../../components/NavBar";

import useSWR, { useSWRConfig } from "swr";

import { api } from "../../api/api";
import { PermissionsModal } from "../../components/Modals/Permissions";
import { useState } from "react";
import '../admin.css'

export function PageUsers() {
  const [userId, setUserId] = useState(null)

  const { mutate } = useSWRConfig()
  const { data } = useSWR('/users', async () => {
    const response = await api.get('/users')

    return response.data
  })

  return (
    <>
      <NavBar>
        <PermissionsModal userId={userId} reload={() => mutate('/users')} clearSelectUser={() => setUserId(null)} />
        <main className="admin-page users-page">
          <header className="admin-page-header"><div><h1>Usuários</h1><p>Gerencie acessos, funções e permissões da equipe</p></div><button className="admin-primary-button" onClick={() => new window.bootstrap.Modal(document.getElementById('modalPermissions'), {}).toggle()}><FiPlus /> Novo usuário</button></header>
          <section className="admin-surface">
            <div className="admin-surface-header"><div><h2>Equipe cadastrada</h2><p>{data?.length || 0} usuários</p></div><FiUsers size={19} /></div>
          <div className="admin-table-wrap">
            <table className="admin-table">
              <thead>
                <tr>
                  <th>Nome</th>
                  <th>E-mail</th>
                  <th >Tipo</th>
                  <th >Ativo</th>
                  <th >Permissões</th>
                </tr>
              </thead>
              <tbody>
                {data?.map((user) => {
                  return (
                    <tr key={user.id}>
                      <td data-label="Nome"><strong>{user.name}</strong></td>
                      <td data-label="E-mail">{user.email}</td>
                      <td data-label="Tipo">
                        {{ admin: 'Administrador', sub_admin: 'Gerente', garcom: 'Garçom', user: 'Usuário' }[user.typeUser]}
                      </td>
                      <td data-label="Status">
                        {user.status ? <span className="admin-status active">Ativo</span> : <span className="admin-status inactive">Inativo</span>}
                      </td>
                      <td data-label="Permissões">
                          <button className="admin-icon-button" aria-label="Editar usuário" onClick={() => {
                            setUserId(user.id)
                          }}><FiEdit3 /></button>
                      </td>
                    </tr>
                  )
                })}
              </tbody>
            </table>
            {data?.length === 0 && <div className="admin-empty"><FiUsers size={25} /><strong>Nenhum usuário cadastrado</strong></div>}
          </div>
          </section>
        </main>
      </NavBar>
    </>
  )
}
